import { render, staticRenderFns } from "./PlayerStatus.vue?vue&type=template&id=7fc46845"
import script from "./PlayerStatus.vue?vue&type=script&lang=ts"
export * from "./PlayerStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports